import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from '../layouts/full/shared/loadable/Loadable';

/* ***Layouts**** */
// const FullLayout = Loadable(lazy(() => import('../layouts/full/FullLayout')));
const TeacherLayout = Loadable(lazy(() => import('../layouts/teacher/FullLayout')));
const UserLayout = Loadable(lazy(() => import('../layouts/user/FullLayout')));

const AdminLayout = Loadable(lazy(() => import('../layouts/admin/FullLayout')));

const BlankLayout = Loadable(lazy(() => import('../layouts/blank/BlankLayout')));

// import AuthGuard from 'src/guards/authGuard/AuthGuard';

import GuestGuard from 'src/guards/authGuard/GuestGaurd';
import RoleGuard from 'src/guards/authGuard/RoleGurad';
import WebLayout from 'src/layouts/web';
import Session from 'src/views/teacher/Session/Session';
import UserSession from 'src/views/web/dashboard/Session';
import Payment from 'src/views/teacher/Payment/Payment';
import Details from 'src/views/teacher/Payment/Details';
import UserPayment from 'src/views/web/dashboard/Payment';
import UserDetails from 'src/views/web/dashboard/Details';
import Request from 'src/views/admin/Request/Request';

/* ****Pages***** */
const SamplePage = Loadable(lazy(() => import('../views/sample-page/SamplePage')));
const CourseWeb = Loadable(lazy(() => import('../views/web/Course')));
const CourseDetail = Loadable(lazy(() => import('../views/web/CourseDetail')));
const Contact = Loadable(lazy(() => import('../views/web/Contact')));
const About = Loadable(lazy(() => import('../views/web/About')));
const UserLogin = Loadable(lazy(() => import('../views/web/auth/Login')));
const UserSignup = Loadable(lazy(() => import('../views/web/auth/Signup')));

const WebError = Loadable(lazy(() => import('../views/web/404')));

// user
const UserCourseList = Loadable(lazy(() => import('../views/web/dashboard/index')));

// const CommingSoon = Loadable(lazy(() => import('../views/CommingSoon')));

const Error = Loadable(lazy(() => import('../views/authentication/Error')));

// Admin
// authentication
const AdminLogin = Loadable(lazy(() => import('../views/admin/authentication/auth1/Login')));
const AdminRegister = Loadable(lazy(() => import('../views/admin/authentication/auth1/Register')));
// admin teacher
const AdminTeacherList = Loadable(lazy(() => import('../views/admin/teacher/List')));
const AdminTeacherProfile = Loadable(
  lazy(() => import('../views/admin/teacher/user-profile/UserProfile')),
);

// Teacher
// authentication

const TeacherLogin = Loadable(lazy(() => import('../views/teacher/authentication/auth1/Login')));
const TeacherRegister = Loadable(
  lazy(() => import('../views/teacher/authentication/auth1/Register')),
);
// profile
const TeacherProfile = Loadable(lazy(() => import('../views/teacher/userProfile/UserProfile')));
const TeacherProfileEdit = Loadable(lazy(() => import('../views/teacher/userProfile/UserEdit')));
// cousrse
const TeacherCourseList = Loadable(lazy(() => import('../views/teacher/Course/List')));
const TeacherChapterList = Loadable(lazy(() => import('../views/teacher/chapter/List')));
const TeacherChapterDetail = Loadable(lazy(() => import('../views/teacher/chapter/Details')));

const Router = [
  {
    path: '/',
    element: <WebLayout />,
    children: [
      { path: '', index: true, element: <Navigate to="/course" /> },
      { path: 'course', index: true, element: <CourseWeb /> },
      { path: 'course/detail/:id', index: true, element: <CourseDetail /> },
      { path: 'contact', index: true, element: <Contact /> },
      { path: 'about', index: true, element: <About /> },
      {
        path: 'login',
        element: (
          <GuestGuard>
            <UserLogin />
          </GuestGuard>
        ),
      },
      {
        path: 'signup',
        element: (
          <GuestGuard>
            <UserSignup />
          </GuestGuard>
        ),
      },
      { path: '404', element: <WebError /> },
      { path: '*', element: <Navigate to="/404" /> },
    ],
  },
  // user
  {
    path: '/user',
    element: (
      <RoleGuard allowedRoles="user">
        <UserLayout />
      </RoleGuard>
    ),
    children: [
      { path: '', index: true, element: <Navigate to="/user/course/list" /> },
      { path: 'course/list', index: true, element: <UserCourseList /> },
      { path: 'course/list/:id', index: true, element: <UserCourseList /> },
      { path: 'session', index: true, element: <UserSession /> },
      { path: 'payment', index: true, element: <UserPayment /> },
      { path: 'payment/detail/:id', index: true, element: <UserDetails /> },


      { path: '404', element: <Error /> },
      { path: '*', element: <Navigate to="user/404" /> },
    ],
  },
  {
    path: '/teacher',
    element: (
      <RoleGuard allowedRoles="teacher">
        <TeacherLayout />
      </RoleGuard>
    ),
    children: [
      { path: '', index: true, element: <Navigate to="/teacher/course/list" /> },
      { path: 'course/list', index: true, element: <TeacherCourseList /> },
      { path: 'session', index: true, element: <Session /> },
      { path: 'course/list/:id', index: true, element: <TeacherCourseList /> },
      { path: 'course/:id', index: true, element: <TeacherChapterList /> },
      { path: 'course/:courseid/chapter/:id', index: true, element: <TeacherChapterDetail /> },
      { path: 'payment', index: true, element: <Payment /> },
      { path: 'payment/detail/:id', index: true, element: <Details /> },

      // profile
      { path: 'user', index: true, element: <TeacherProfile /> },
      { path: 'user/edit', index: true, element: <TeacherProfileEdit /> },
      { path: '404', element: <Error /> },
      { path: '*', element: <Navigate to="teacher/404" /> },
    ],
  },
  // admin Routes
  {
    path: '/admin',
    element: (
      <RoleGuard allowedRoles="admin">
        <AdminLayout />
      </RoleGuard>
    ),
    children: [
      { index: true, element: <Navigate to="/admin/teacher/list" /> },
      { path: 'teacher/list', index: true, element: <AdminTeacherList /> },
      { path: 'teacher/profile/:id', index: true, element: <AdminTeacherProfile /> },
      { path: 'request', index: true, element: <Request /> },

      { path: 'sample-page', exact: true, element: <SamplePage /> },
      { path: '404', element: <Error /> },
      { path: '*', element: <Navigate to="admin/404" /> },
    ],
  },

  {
    path: '/auth',
    element: (
      <GuestGuard>
        <BlankLayout />
      </GuestGuard>
    ),
    children: [
      {
        path: 'teacher',
        children: [
          { path: 'login', element: <TeacherLogin /> },
          { path: 'register', element: <TeacherRegister /> },
        ],
      },
      {
        path: 'admin',
        children: [
          { path: 'login', element: <AdminLogin /> },
          { path: 'register', element: <AdminRegister /> },
        ],
      },
      { path: '404', element: <Error /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
];

export default Router;
